import { isSubscribedPlan } from '../../pricing/pricing.utils.js';
import { MAX_UPLOAD_SIZE_FREE } from '../../store/fileUploadStore.js';
import { getCompatFile } from '@fabric-app/compat/capabilities/file';
import { UploadErrorCode } from '@fabric-app/types/upload';
import { UploadError } from '../upload.error.js';
import { isInDesktopPlatform } from '@fabric-app/compat/capabilities/platform';
import { getToDesktopStreamChunk } from './getToDesktopStreamChunk.js';

const prepareUploadFile = async (options) => {
  const fileCompat = getCompatFile();
  if (!options.data.available) {
    throw new UploadError(UploadErrorCode.FileNotAvailable);
  }
  let file;
  let fileSize;
  if (options.data.type === "file") {
    file = options.data.file;
    fileSize = file.size;
  } else if (options.data.type === "uri") {
    if (!fileCompat.getIsAvailable()) throw new UploadError(UploadErrorCode.FileNotAvailable);
    const fileData = await fileCompat.readFile({
      url: options.data.file.uri,
      maxBytes: 4100
    });
    const byteArray = Buffer.from(fileData.content, "base64");
    const blob = new Blob([
      byteArray
    ], {
      type: fileData.contentType
    });
    file = new File([
      blob
    ], fileData.name, {
      type: fileData.contentType
    });
    fileSize = fileData.size;
  } else {
    if (!isInDesktopPlatform()) throw new UploadError(UploadErrorCode.FileNotAvailable);
    fileSize = options.data.file.size;
    const blob = await getToDesktopStreamChunk(options.data.stream, fileSize, options.data.file.mimeType, 0, 4100);
    file = new File([
      blob
    ], options.data.file.name, {
      type: options.data.file.mimeType
    });
  }
  if (fileSize > MAX_UPLOAD_SIZE_FREE && !isSubscribedPlan(options.userTier ?? void 0)) {
    throw new UploadError(UploadErrorCode.FileTooLarge);
  }
  return {
    file,
    fileSize
  };
};

export { prepareUploadFile };
//# sourceMappingURL=prepareUploadFile.js.map
